<template>
    <login-content class-name="m-login">
        <template slot="form">
            <div class="login-title">登 录</div>
            <el-form ref="form" :model="forms" class="login-form" :rules="rules">
                <el-form-item prop="username" class="m-b-25">
                    <el-input v-model="forms.username"  placeholder="登录名" autofocus suffix-icon="iconfont icon-login_account1"  @keyup.native.enter="login"></el-input>
                </el-form-item>
                <el-form-item prop="password" class="m-b-25">
                    <el-input v-model="forms.password" type="password"  placeholder="密码" autocomplete="off" suffix-icon="iconfont icon-login_password1" @keyup.native.enter="login"></el-input>
                </el-form-item>
                <el-form-item prop="remember" class="button_item">
                    <el-button type="primary" class="submit" :disabled="disOk" @click="login">{{okText}}</el-button>
                </el-form-item>
            </el-form>
            <div class="to-register" @click="register">还没注册？</div>
        </template>  
    </login-content>
</template>

<script>
import loginContent from '@/components/loginContent'
import API from '@/fetch/api';
import * as access from "@/config/access";
import { checkStatus } from '@/common/util/constans' 

export default {
    data(){
        return {
            okText: '登录',
            forms: {
                oauth_type: 'merchant',
                grant_type: 'password',
                username: '',
                password: ''
            },
            rules: {
                username: [
                    { required: true, message: '登录名不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ],
            },
            checkStatus,
        }
    },
    components: {
        loginContent
    },
    mounted(){

    },
    computed: {
        disOk(){
            return !this.forms.username || !this.forms.password || this.okText != '登录';
        }
    },
    methods: {
        login(){
            let vm = this;
            vm.$refs.form.validate((valid) => {
                if (!valid) return;
                access.session('token', '');
                vm.okText = '登录中...';
                API.http({url: '/oauthep/uaa/oauth/token', type: 'post',
                    params: vm.forms,
                    postType: 'urlencoded',
                }).then(res => {
                    vm.okText = '登录'
                    if(res.access_token) {
                        vm.parseLogin(res);
                        return;
                    }
                    vm.$showAlert(res.message || res.error ||  '登录失败，请重试', 'error')
                }).catch(res => {
                    vm.okText = '登录'
                    vm.$showAlert(res.error_description || '登录失败，请重试', 'error');
                    return;
                })
            })
            
        },
        //登录成功
        parseLogin(res){
            let vm = this;
            //新版本
            access.session('managerNo', res.managerNo )
            access.session('userNo', { userNo: res.managerNo });
            access.session('token', { token: res.access_token });
            access.session('refresh_token', { token: res.refresh_token });
            access.session('userId', { userId: res.userid });
            access.session('userName', { userName: vm.forms.username });
            access.session('realName', { realName: res.realName });
            access.session('companyId', { companyId: res.companyId });
            access.session('managerType', { managerType: res.managerType });
            vm.$emit('logged');
        },
        register(){
            this.$router.push({ name:  'register'});
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../style/variable';
    .m-login{
        .login-title{
            margin-bottom: 60px;
            text-align: center;
            font-size: 34px;
            font-family: Microsoft YaHei;
            color: $c4;
        }
        .login-form{
            width: 100%;
            .button_item{
                margin-top: 60px;
                .submit{
                    width: 100%;
                    padding: 0;
                    height: 40px;
                    line-height: 40px;
                    background-color: $c4;
                    border-color: $c4;
                    &.is-disabled{
                        background-color: $btn-login-dis;
                        border-color: $btn-login-dis;
                    }
                }
            }
        }
        .to-register{
            margin-top: 22px;
            color: $c4;
            text-align: center;
            font-size: 12px;
            text-decoration: underline;
            cursor: pointer;
        }
    }
</style>   